module.exports = __webpack_public_path__ + "static/media/eliminar.276f8d9d.svg";